import React from 'react';
import { Container } from '@mui/material';
import './VideoSkeleton.css';

const VideoSkeleton = () => {
    return (
        <Container maxWidth="lg">
            <div className="skeleton-container">
                <div className="skeleton-video">
                    <div className="skeleton-shimmer" />
                </div>

                <div className="skeleton-controls">
                    <div className="skeleton-button" />
                    <div className="skeleton-title" />
                    <div className="skeleton-button" />
                </div>

                <div className="skeleton-info">
                    <div className="skeleton-text" />
                    <div className="skeleton-text" />
                    <div className="skeleton-text" />
                </div>
            </div>
        </Container>
    );
};

export default VideoSkeleton; 